import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop"; 
import Header from "./components/Header";
import Footer from "./components/Footer";
import content from "./data/content";
import PageRenderer from "./components/PageRenderer";

function AppLayout() {
  const location = useLocation();

  // Get route segment (e.g., "home", "about")
  const routeClass = location.pathname === "/" ? "home" : location.pathname.replace("/", "");

  return (
    <>
      <ScrollToTop />
      <Header />

      <Routes>
        {Object.keys(content).map((pageKey) => (
          <Route
            key={pageKey}
            path={`/${pageKey === "home" ? "" : pageKey}`}
            element={<PageRenderer blocks={content[pageKey]} />}
          />
        ))}
      </Routes>

      <Footer className={routeClass} />
    </>
  );
}

function App() {
  return (
    <Router>
      <AppLayout />
    </Router>
  );
}

export default App;
